// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__bTyYW","logo":"Footer_logo__q5vAW","plainLink":"Footer_plainLink__w1Dyw","blueLink":"Footer_blueLink__6_DQz","icon":"Footer_icon__rjWIx"};